import Api from '../Base'

export default class DeleteShelf extends Api {
  requestUrl = `/api/Shelf/${this.getParams().id}`

  method = 'DELETE'
}
